@if (mainImage$ | async; as main) {
  @if (isVideo(main)) {
    <custom-video [data]="convertToVideoSource(main)"></custom-video>
  } @else {
    <cx-media [container]="main" (click)="triggerZoom(true)"></cx-media>
  }
  <cx-product-image-zoom-trigger
    [expandImage]="expandImage.value"
    [galleryIndex]="$any(selectedIndex)"
    (dialogClose)="triggerZoom(false)"
  ></cx-product-image-zoom-trigger>
}

@if (thumbs$ | async; as thumbs) {
  @if (thumbs.length) {
    <cx-carousel
      class="thumbs"
      [items]="thumbs"
      itemWidth="120px"
      [hideIndicators]="false"
      [template]="thumb"
    ></cx-carousel>
  }
}

<ng-template #thumb let-item="item">
  <cx-media
    [container]="item.container"
    tabindex="0"
    (focus)="openImage(item.container)"
    [class.is-active]="isActive(item.container) | async"
    format="thumbnail"
    >
  </cx-media>
</ng-template>
